module.exports = __webpack_public_path__ + "2020celebration/img/accident-r-2.4008b387.png";